import cfg from 'cfg';
import { requestAsync } from 'redux-query';
import { STORE_KEYS, SPORTS } from '../constants';
import { createApiFetchById, createApiFetch } from './helpers';
import { tournamentsKey } from '../selectors';

const ss2 = cfg.apis.ss2;

export const fetchTournamentById = tournamentId => {
    const url = ss2 + '/tournaments/' + tournamentId;
    return createApiFetchById({
        id: tournamentId,
        url,
        key: STORE_KEYS.TOURNAMENTS + STORE_KEYS.BY_ID
    });
};

export const fetchAllTournaments = () => {
    const url = ss2 + '/tournaments';
    return requestAsync(
        createApiFetch({
            url,
            key: STORE_KEYS.TOURNAMENTS,
            configOptions: {
                force: false
            }
        })
    );
};

export const fetchTournamentsBySport = sportId => {
    const key = tournamentsKey(sportId);
    return requestAsync({
        url: ss2 + '/tournaments' + (sportId ? '?sportId=' + sportId : ''),
        queryKey: key,
        transform: response => ({
            [key]: Array.isArray(response)
                ? response.filter(tournament => cfg.triggerer.supportedLeagues.indexOf(tournament.id) !== -1)
                : []
        }),
        update: {
            [key]: (prev, next) => next
        }
    });
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/actions/tournaments.js
 **/